
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import Breadcrumb from '@/components/Breadcrumb/index.vue';
import Hamburger from '@/components/Hamburger/index.vue';
import Pass from '@/components/Pass/index.vue';
import { updatePWD } from '@/api/users';
import { toast } from '@/utils/common';
@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger,
    Pass,
  },
})
export default class extends Vue {
  model = {
    oldPass: '',
    pass: '',
    passAgain: '',
  };
  visiblePass: boolean = false;
  brandDialogVisible: boolean = false;
  brandForm: { app_id: string; is_default: boolean } = {
    app_id: '',
    is_default: false,
  };
  get brands() {
    return UserModule.brands;
  }

  get name() {
    return UserModule.name;
  }
  get sidebar() {
    return AppModule.sidebar;
  }

  get device() {
    return AppModule.device.toString();
  }

  get avatar() {
    return UserModule.avatar;
  }

  private showBrands(): void {
    this.brandForm.app_id = UserModule.activeBrand;
    this.brandDialogVisible = true;
  }

  private saveBrand(): void {
    this.brandDialogVisible = false;
    const brand = this.brands.find(x => x.id === this.brandForm.app_id);
    if (!brand) {
      return;
    }
    UserModule.brandSwitch(this.brandForm)
      .then(() => {
        this.$router.push('/');
        location.reload();
      })
      .catch(() => {
        this.$message.error('切换品牌失败');
      });
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false);
  }

  private logout() {
    UserModule.LogOut();
    location.reload();
    // this.$router.push(`/login`);
  }
  showUpdatePassWord() {
    this.visiblePass = true;
  }
  //修改密码
  async updatePassWord() {
    try {
      const res = await updatePWD({ old: this.model.oldPass, new: this.model.pass });
      if (res.code == 0) {
        toast('修改成功!请重新登录');
        setTimeout(() => {
          UserModule.LogOut();
          location.reload();
        }, 1000);
      } else {
        toast('修改失败' + res.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }
  mounted() {
    console.log('💂', name);
  }
}
